<script lang="ts" setup>
const { t } = useLang()

const { className } = useTheme()
const runtimeConfig = useRuntimeConfig()

const logos = await useAssetManager().getLogos()
const props = defineProps({
  error: {
    type: Object,
    default: null,
  },
})

const handleError = () => clearError({ redirect: '/' })
const reloadPage = () => {
  if (typeof window !== 'undefined') {
    window.location.reload(true)
  }
}

const isDeployError = computed(() => {
  const error = ((props.error?.message ?? '') as string).toLowerCase()

  return (
    error.includes('dynamically imported module') ||
    error.includes('module script failed') ||
    error.includes('preload css')
  )
})

useHead(() => ({
  meta: [
    {
      name: 'robots',
      content: 'noindex',
    },
  ],
}))
</script>

<template>
  <div class="flex flex-col h-screen" :class="className">
    <template v-if="isDeployError">
      <main class="flex-1 text-center flex flex-col items-center py-[6.5rem] px-4">
        <div class="flex items-center justify-center w-full lg:w-2/3 mb-16">
          <img :src="logos.logoBlack" class="max-h-40 dark:invert" />
        </div>
        <h3 v-text="t('error.deploy_title')" />
        <span class="pt-4 pb-[3rem]" v-text="t('error.deploy_subtitle')" />
        <Button class="max-w-max" @click="reloadPage">
          {{ t('error.refresh') }}
        </Button>
      </main>
    </template>
    <template v-else>
      <header class="py-8">
        <img class="mx-auto h-14 dark:invert" :src="logos.logoBlack" alt="Logo" />
      </header>
      <main class="flex-1 text-center flex flex-col items-center py-[6.5rem] px-4">
        <h3 v-text="t('error.unexpected')" />
        <span class="pt-4 pb-[3rem]" v-text="t('error.trying-to-resolve')" />
        <template v-if="runtimeConfig.public.debug">
          <pre class="text-left max-w-[90vw]">{{ JSON.stringify(props.error, null, 4) }}</pre>
          <pre class="text-left max-w-[90vw] pt-6" v-html="props.error.stack"></pre>
        </template>
        <Button class="max-w-max" @click="handleError">
          {{ t('error.return-to-homepage') }}
        </Button>
      </main>
    </template>
    <footer class="flex text-gray4 p-4">
      <span class="mx-auto" v-text="t('footer.all-rights-reserved', { year: new Date().getFullYear() })"> </span>
    </footer>
  </div>
</template>

<style lang="postcss" scoped>
header {
  border-bottom: theme('vars.borderLight');
}

footer {
  background-color: theme('colors.gray8');
}
</style>
